import { DefaultNodeTemplate } from './default-node-template';

export const NodeTemplateMap = () => ({
  category: '',
  template: DefaultNodeTemplate(),
});
